<!--新增坏件单-->
<template>
  <el-dialog
    :title="getTitle()"
    :visible.sync="dialogSeeVisible"
    center
    :close-on-click-modal="false" :append-to-body="true"
    custom-class="medium-dialog"
  >
    <div ref="print1" style="width: 850px;margin: 0 auto;">
      <p :style="{display:showtitle1,textAlign:'center',fontSize:'18px',lineHeight:'40px'}">{{getTitle()}}</p>
      <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
             class="query-table">
        <tr class="noborder">
          <td align="right" width="60">入&nbsp;&nbsp;&nbsp;&nbsp;库：</td>
          <td width="200">
            <el-select v-model="controlData.cangkucode" placeholder="请选择" size="mini" @change="changename">
              <el-option
                v-for="item in jxcstoreData"
                :key="item.cangkucode"
                :label="item.cangkuname"
                :value="item.cangkucode">
              </el-option>
            </el-select>
          </td>
          <td align="right" width="80">责任人：</td>
          <td colspan="4">
            <CommonTree ref="treeDserial" :treeHeight="180" :searchText="form.applyby" :inputSize="'mini'"
                        @check="checktreeZZR"></CommonTree>
          </td>
        </tr>
        <tr class="noborder">
          <td align="right">品  牌：</td>
          <td colspan="6">
            <CommonTree ref="treeSeed" :inputSize="'mini'" :defineDataSource="true" @bindData="bindData"
                        :treeWidth="450"
                        :onlyShowGroupType="false" :needTopNode="false" :onlySelectChild="true"
                        :treeHeight="300" :searchText="form.seedname"
                        @check="checktree1"></CommonTree>
          </td>
        </tr>
        <tr class="noborder">
          <td align="right" width="60">入库原因：</td>
          <td colspan="5">
            <el-radio-group v-model="ordername">
              <el-radio label="验光原因">验光原因</el-radio>
              <el-radio label="顾客原因">顾客原因</el-radio>
              <el-radio label="质量问题">质量问题</el-radio>
              <el-radio label="加工损坏">加工损坏</el-radio>
              <el-radio label="商品过期">商品过期</el-radio>
              <el-radio label="其他原因">其他原因</el-radio>
            </el-radio-group>
          </td>
        </tr>
        <tr class="noborder">
          <td>备注：</td>
          <td colspan="5">
            <textarea style="width: 100%;height: 40px" v-model="controlData.remark"></textarea>
          </td>
        </tr>
        <!--<tr class="noborder">-->
          <!--<td align="right" width="60">订单号：</td>-->
          <!--<td width="140">系统自动生成</td>-->
          <!--<td align="right" width="80">时&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;间：</td>-->
          <!--<td width="220">{{controlData.adddate}}</td>-->
          <!--<td width="60"></td>-->
          <!--<td width="140"></td>-->
        <!--</tr>-->
        <tr class="noborder" v-if="addtype==1">
          <td align="right">供应商：</td>
          <td>
            <el-select v-model="controlData.pcustomerserial" placeholder="请选择" size="mini" @change="changepcu">
              <el-option
                v-for="item in ptableData"
                :key="item.customerserial"
                :label="item.deptname"
                :value="item.customerserial">
              </el-option>
            </el-select>
          </td>
          <td align="right">供应号：</td>
          <td>
            <el-input v-model="tracknum" size="mini" ref="tracknum" placeholder="请输入供应商单号" @change="scanTracknum"
                      onfocus="this.select()"></el-input>
          </td>
          <td align="right">跟踪号：</td>
          <td>
            <el-input v-model="logisticstracknum" size="mini" ref="logisticstracknum" placeholder="请输入跟踪单号"
                      onfocus="this.select()"
            ></el-input>
          </td>
        </tr>
        <tr class="noborder">
          <td></td>
          <td></td>
          <td></td>
          <td>总数:{{totalnumber}}</td>
          <td style="padding-left: 60px" colspan="2">
            <el-button type="success" v-on:click="addFrame" size="mini">增 加</el-button>
              <el-button size="mini" type="success" @click.stop.prevent="showGoodDetailSel()">选择
            </el-button>
          </td>
        </tr>
        <tr class="noborder">
          <td colspan="6">
            <el-table
              :data="tableData"
              size="mini"
              stripe
              border
              style="width: 100%;">
              <el-table-column
                type="index"
                :index="indexMethod"
                align="center"
                label="序号"
                width="50">
              </el-table-column>

              <!--<el-table-column-->
                <!--prop="seedcode"-->
                <!--label="编码"-->
                <!--align="center"-->
                <!--width="130"-->
                <!--header-align="center">-->
              <!--</el-table-column>-->
              <el-table-column
              prop="seedname"
              label="名称"
              align="left"
              header-align="center">
              </el-table-column>
              <el-table-column
                prop="model"
                label="型号"
                width="120"
                align="left"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="color"
                label="色号"
                width="120"
                align="left"
                header-align="center">
              </el-table-column>
              <el-table-column
                prop="totalnumber"
                label="数量"
                align="center"
                width="120"
                header-align="center">
                <template slot-scope="scope">
                  <el-input style="width: 100%" size="small" v-model="scope.row.totalnumber"
                            :ref='scope.row.id'
                            onfocus="this.select()"
                            @keyup.enter.native="validateCounts(scope.row,scope.$index, $event,'')"
                            @keyup.down.native="validateCounts(scope.row,scope.$index, $event,'')"
                            @keyup.up.native="validateCounts(scope.row,scope.$index, $event,'')"
                            @change="totalNumber"></el-input>
                </template>
              </el-table-column>
              <!--<el-table-column-->
                <!--prop="barcodes"-->
                <!--label="扫码"-->
                <!--align="left" -->
                <!--header-align="center">-->
                <!--<template slot-scope="scope">-->
                  <!--<el-input style="width: 80%" size="mini" v-model="scope.row.onlycode"-->
                            <!--:ref="'code'+scope.row.id"-->
                            <!--onfocus="this.select()"-->
                            <!--@keyup.down.native="validateCounts(scope.row,scope.$index, $event,'code')"-->
                            <!--@keyup.up.native="validateCounts(scope.row,scope.$index, $event,'code')"-->
                            <!--@change="selectonlyonecode(scope.row)"></el-input>-->
                  <!--<div v-for="item in scope.row.barcodes" :key="item.storegoodsbarcode">-->
                    <!--{{item.storegoodsbarcode}}&nbsp;&nbsp;&nbsp;<i class="el-icon-close" style="cursor: pointer" @click="clearBar(item.storegoodsbarcode,scope.row)"></i>-->
                  <!--</div>-->
                <!--</template>-->
              <!--</el-table-column>-->
              <el-table-column label="操作" align="center" width="130">
                <template slot-scope="scope">
                  <el-button size="mini" type="danger"
                             @click="handleDelete(scope.$index, scope.row)">删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </td>
        </tr>
        <tr class="noborder">
          <td colspan="6">
          </td>
        </tr>
      </table>
    </div>
    <div slot="footer" class="dialog-footer no-print">
      <el-button @click="dialogSeeVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveData" :loading="loading">确认</el-button>
      <BatchBuyFormProperties ref="batchBuyFormProperties" @afterSelectCode="afterSelectCode"></BatchBuyFormProperties>
      <MakeInventoryFrameAdd ref="MakeInventoryFrameAdd" @afterSelect="afterSelect"></MakeInventoryFrameAdd>
    </div>
  </el-dialog>
</template>


<script>
  import {getRemark} from '@/plugin/ordercommon'
  import MakeInventoryFrameAdd from './MakeInventoryFrameAdd';
  import {listgoodsframe, getDetail, getGoodsTree,jingjiaupload} from '@/api/set/jxcgooddetail';
  import {getPrice} from '@/api/set/goodsprice';
  import TwoDimensionalTable from '@/components/set/goodsprice/TwoDimensionalTable';
  import {getpcustomerserial} from '@/api/set/csagreement';
  import {addstoragebad} from '@/api/set/warehouse'
  import {getListData,cusandptbyind} from '@/api/set/jxcstore'
  import {suppliers} from '@/api/set/externaldept';
  import {loadSpecFrame} from '@/plugin/ordercommon'
  import JxcgooddetailSel from '@/components/set/jxcgooddetail/JxcgooddetailSel';
  import BatchBuyFormProperties from '../testorder/buyagreement/BatchBuyFormProperties'

  export default {
    name: 'AddStorageBad',
    msg:'仓库岗 添加坏件（供应商多发、正式库转入）',
    data() {
      return {
        book: {XStart: 0, XEnd: 0, XSpace: 0, YStart: 0, YEnd: 0, YSpace: 0, BookContent: []},
        costpricebook: {},
        dialogFormVisible: false,
        goodsbarcode:'',
        totalnumber:0,
        title: "",
        index: -99,
        seedgoods: [],
        dialogSeeVisible: false,
        formLabelWidth: '120px',
        groupguid: '',
        remark: '',
        pcustomerserial:'',
        cangkucode: '',
        cangkuname: '',
        cangkucodes: [],
        pingpainame:'',
        ordername:'',
        tableData: [],
        addtype:1,
        unitguid: "",
        column: [],
        ptableData: [],
        controlData: {},
        storenumtable: [],
        showtitle1: "none",
        jxcstoreData: [],
        filltemplate: "",
        num: 0,
        canshowgoodsel: true,
        form: {  //表单数据
          unitguid: "",
          bookstr: "",
          seedcode: "",
          seedname: "",
          seedinfo:"",
          applybyguid:"",
          applyby:""
        },
        tracknum: '',//供应商单号
        logisticstracknum: '',//跟踪单号
        loading: false,
        scangoodscode:[],
        seedcodeData:[]
      }

    },
    methods: {

      checktreeZZR(guids, names, arr) {
        this.form.applybyguid = guids;
        this.form.applyby = names;
      },
      //回车跳入下一行
      validateCounts(row, index, e ,pre) {
        var keyCode = e.keyCode || e.which || e.charCode;
        if (keyCode == 40 || keyCode === 13) {//回车，下方向键
          this.$refs[pre+row.id].blur()
          if (this.tableData.length - 1 === index) {
            index = -1
          }
          this.$refs[pre + (index + 1)].focus();
        } else if (keyCode == 38) {//上方向键
          this.$refs[pre+row.id].blur()
          if (index === 0) {
            index = this.tableData.length
          }
          this.$refs[pre + (index - 1)].focus();
        }
      },
      showGoodDetailSel() {
        if (this.seedcodeData.length == 0) {
          this.$message.error("请先选择商品分类");
          return
        }
        for (let i in this.seedcodeData) {
          this.seedcodeData[i].totalnumber = 0
        }
        //参数  true 显示库存，seedcode分类，cangkucode 仓库，seedcodeData 分类下的商品
        this.$refs.batchBuyFormProperties.initData(true, this.form.seedcode, this.controlData.cangkucode, this.seedcodeData, this.controlData.pcustomerserial)
      },
      addFrame(){
        if (this.seedcodeData.length >0) {
          this.$refs.MakeInventoryFrameAdd.show(this.seedcodeData)
        } else {
          this.$message({
            message: '请先选择商品分类！',
            type: 'warning'
          });
        }
      },
      //给tableData 添加 id，共回车使用
      indexMethod(index) {
        this.tableData[index].id = index
        return index + 1;
      },
      error(msg) {
        this.$message({
          message: msg,
          type: 'error'
        })
      },
      jingjiaupload() {
        if (this.controlData.cangkucode && this.form.seedcode && this.form.seedcode.length >= 9) {
          this.$refs.fileupload.value = ""
          this.$refs.fileupload.click()
        } else {
          this.$message({
            message: '请先选择仓库、商品类别！',
            type: 'warning'
          });
        }
      },
      change1(event) {
        try {
          var reg = /(\.xls|\.xlsx)$/
          if (!reg.test(event.target.files[0].name)) {
            this.$message.error("只能导入.xls或者.xlsx的文件！")
            return
          }
          this.$importExcel(event.target.files[0], (data) => {
              var catename = this.pingpainame +this.form.seedname.replace(this.pingpainame, '')
              let arr = loadSpecFrame(data, this.form.seedcode, catename);
              if (arr.length > 0) {
                var loadTable=[]
                var addTable=[]
                for (var i in arr) {
                  if (arr[i].minnumber == 0) {//没填写数量的不导
                    continue;
                  }

                  var MandC = JSON.parse(arr[i].goodsframe)[0];

                  //检查是否存在
                  for (let j in this.seedcodeData) {
                    if (this.seedcodeData[j].model == MandC.model) {//有型号
                      if ((';' + this.seedcodeData[j].color + ';').indexOf(';' + MandC.color + ';') > -1) {
                        loadTable.push({
                          seedcode: this.seedcodeData[j].seedcode,
                          seedname: this.seedcodeData[j].seedname,
                          color: MandC.color,
                          model: MandC.model,
                          categorycode: this.seedcodeData[j].categorycode,
                          totalnumber: arr[i].minnumber
                        });
                      }
                      break;
                    }
                  }
                }
                if(loadTable.length>0){
                  this.afterSelectCode(loadTable);
                }
              }
            }
          )
        } catch (ee) {
          this.$message.error("导入失败")
        }
      },
      afterSelect(arr){
        for (let i in arr) {
          arr[i].model=arr[i].M
          arr[i].color=arr[i].C
          arr[i].totalnumber=arr[i].P
        }
        this.afterSelectCode(arr);
      },
      afterSelectCode(arr) {
        let count = 0;//记录当前订单是否需要弹出提示
        for (let i in arr) {
          let biaoji = 0
          for (let j in this.tableData) {
            //判读该商品是否属于
            if (this.tableData[j].seedcode == arr[i].seedcode && this.tableData[j].model == arr[i].model && this.tableData[j].color == arr[i].color) {
              biaoji = 1
              this.tableData[j].totalnumber = arr[i].totalnumber;//更新数量
              count++;
              break
            }
          }
          if (biaoji == 0) {
            this.tableData.push({
              seedcode: arr[i].seedcode,
              seedname: arr[i].seedname,
              color:arr[i].color,
              model:arr[i].model,
              categorycode: '',
              totalnumber: arr[i].totalnumber,
              formproperty: '[{}]',
              packagesize:'{"M":"'+arr[i].model+'","C":"'+arr[i].color+'"}',
              onlycode:'',
              barcodes:[]
            })
          }
        }
        //从小到大排序
        this.tableData.sort(function (a, b){
          if (a.model == b.model)
            return a.color.localeCompare(b.color);
          else
            return a.model.localeCompare(b.model);
        });
        this.totalNumber()
        // if (count > 0) {
        //   this.$message({
        //     message: "商品已存在！",
        //     type: 'info'
        //   })
        // }
      },
      //购买总数
      totalNumber() {
        this.totalnumber = 0
        for (let i in this.tableData) {
          this.totalnumber = this.totalnumber + parseInt(this.tableData[i].totalnumber)
        }
      },
      //删除明细
      handleDelete(index, row) {
        this.tableData.splice(index, 1)
        this.totalNumber()
      },
      checktree1(guids, names, arr) {
        this.seedcodeData = []
        this.tableData=[]
        this.form.seedcode = guids
        this.form.seedname = names
        this.form.seedinfo = ";" + guids + "," + arr[0].parentId + ";"
        this.pingpainame=guids.length==12?(this.$refs.treeSeed.getNode(guids.substr(0, guids.length - 3)).label):'';

        if (this.form.seedname == "") {
          this.$message({
            message: '请选择类别',
            type: 'warning'
          })
          return
        }
        listgoodsframe({
          categorycode: this.form.seedcode,
          filltemplate: '80',
        }).then(response => {
          this.seedcodeData = response.data.obj
          if (this.seedcodeData.length > 0) {
            for (let i in this.seedcodeData) {
              this.seedcodeData[i].totalnumber = 0
            }
            this.geterweibiao();
          } else {
            this.$message({
              message: '该系列没有备货商品',
              type: 'warning'
            })
            return
          }

        }).catch((error) => {
          console.log(error)
        });

      },
      //供应商单号输入成功后自动跳到跟踪单号框
      scanTracknum() {
        if (this.tracknum) {
          this.$refs.logisticstracknum.focus()
        }
      },
      //获得标题
      getTitle() {
        let result = "";
        let temp = localStorage.getItem("hpapi_userInfoModel")
        if (temp) {
          result += JSON.parse(temp).tenantname || ""
        }
        result += "坏件入库单"
        return result
      },
      //清空商品
      clearSeedCode() {
        this.scangoodscode=[]
        this.form.seedcode = ""
        this.form.seedname = ""
        this.form.filltemplate = ""
        this.canshowgoodsel = false
      },

      //商品树
      bindData() {
        this.$refs.treeSeed.bindData(() => {
          return getGoodsTree({onlyShowGroupType:true,categorystarts:'002;003;004;005;006'})
        })
      },

      //选择供应商
      changepcu(val) {
        for (let i in this.ptableData) {
          if (this.ptableData[i].customerserial == val) {
            this.controlData.pcustomerserial = this.ptableData[i].customerserial
            this.controlData.pcustomer = this.ptableData[i].deptname
            this.controlData.clinkman = this.ptableData[i].linkman
            this.controlData.clinkmantel = this.ptableData[i].linkmantel
            this.controlData.caddress = this.ptableData[i].address
          }
        }
      },

      //取可以使用的供应商
      geterweibiao() {
        this.pcustomerserial = ''
        this.controlData.pcustomerserial = ''
        this.controlData.pcustomer = ''
        // if (this.ptableData.length == 0) {
        //   suppliers({categorycode: this.form.seedcode, search: ""}).then((response) => {
        //     this.ptableData = response.data.obj
        //     if (this.ptableData.length > 0) {
        //       this.pcustomerserial = this.ptableData[0].customerserial
        //       this.controlData.pcustomerserial = this.ptableData[0].customerserial
        //       this.controlData.pcustomer = this.ptableData[0].deptname
        //       this.controlData.clinkman = this.ptableData[0].linkman
        //       this.controlData.clinkmantel = this.ptableData[0].linkmantel
        //       this.controlData.caddress = this.ptableData[0].address
        //     }
        //   })
        // }
      },
      getLiuYan(remark) {
        return getRemark(remark);
      },
      show() {
        this.dialogSeeVisible = true;
      },
      changename(val) {
        for (let i in this.jxcstoreData) {
          if (this.jxcstoreData[i].cangkucode == val) {
            this.controlData.cangkuname = this.jxcstoreData[i].cangkuname;
          }
        }
      },
      contains(item, arr) {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i] == item) {
            return true;
          }
        }
        return false;
      },
      getRemark(remark) {
        if (remark) {
          try {
            let temp = JSON.parse(remark)
            temp.forEach(item => {
              if (item.type == "客户留言") {
                return item.msg
              }
            })
          } catch (ex) {
          }
        }
        return ""
      },

      saveData() {
        this.loading = true
        //根据缓存中oddrequired  true需必填否则不必填
        // if (this.addtype==1&&JSON.parse(localStorage.getItem("hpapi_parames")).other.oddrequired == 'true') {
        //   if (!this.logisticstracknum) {
        //     this.$message({
        //       message: '请输入跟踪单号',
        //       type: 'error'
        //     })
        //     this.loading = false
        //     return
        //   }
        //   if (!this.tracknum) {
        //     this.$message({
        //       message: '请输入供应商单号',
        //       type: 'error'
        //     })
        //     this.loading = false
        //     return
        //   }
        // }
        if(!this.form.applybyguid){
          this.$message({
            message: '责任人必选！',
            type: 'error'
          })
          this.loading = false
          return
        }
        if(!this.ordername){
          this.$message({
            message: '请选择入库原因！',
            type: 'error'
          })
          this.loading = false
          return
        }
        if(this.ordername=='其他原因'&&!this.controlData.remark){
          this.$message({
            message: '请填写备注！',
            type: 'error'
          })
          this.loading = false
          return
        }
        //取出对应的表单详情和数量
        var arr = [];
        for(let i in this.tableData){
          if(this.tableData[i].totalnumber>0){
            this.tableData[i].P=this.tableData[i].totalnumber;
            arr.push(this.tableData[i])
          }
        }

        if (arr != 0) {
          addstoragebad({
            jxcforms: JSON.stringify(arr),
            map: JSON.stringify({
              pcustomerserial: this.controlData.pcustomerserial,
              pcustomer: this.controlData.pcustomer,
              cangkuname: this.controlData.cangkuname,
              cangkucode: this.controlData.cangkucode,
              address: this.controlData.address,
              linkman: this.controlData.linkman,
              linkmantel: this.controlData.linkmantel,
              seedcode: this.form.seedcode,
              seedname: this.form.seedname,
              remark: this.controlData.remark,
              ordername:this.ordername,
              applyby: this.form.applyby,
              applybyguid: this.form.applybyguid,
              tracknum: this.tracknum,
              logisticstracknum: this.logisticstracknum,
              addtype:this.addtype
            })
          }).then(response => {
            if (response.data.code == 0) {
              this.$message({
                message: '保存成功',
                type: 'success'
              })
              this.$emit('bindGrid');
            } else {
              this.$message({
                message: response.data.msg,
                type: 'error'
              })
            }
            this.dialogSeeVisible = false;
            //刷新列表
          });
        } else {
          this.$message({
            message: '请选择订单',
            type: 'error'
          })
          this.loading = false
        }

      },
      initData(type) {
        this.addtype=type;//1 供应商多发，2 正式转入
        this.initForm()
        if (this.jxcstoreData && this.jxcstoreData.length > 0) {
          this.controlData.cangkucode = this.jxcstoreData[0].cangkucode
          this.controlData.cangkuname = this.jxcstoreData[0].cangkuname
        }
      },
      initForm() {
        if (this.$refs.form1 != undefined) {
          this.$refs.form1.resetFields();
        }
        this.scangoodscode=[]
        this.canshowgoodsel = true
        this.controlData = {}
        this.groupguid = ""
        this.column = []
        this.tableData = []
        this.unitguid = ""
        this.filltemplate = ""
        this.index = -99
        this.addvisible = true
        this.form.seedcode = ''
        this.form.seedname = ''
        this.form.applyby=''
        this.form.applybyguid=''
        this.ordername=''
        this.num = 0;
        this.loading = false
      }
    },
    mounted() {
      cusandptbyind().then(response => {
        this.jxcstoreData = response.data.obj

      })
    },

    components: {
      TwoDimensionalTable,
      JxcgooddetailSel,
      BatchBuyFormProperties,
      MakeInventoryFrameAdd
    }

  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }

  .gray1 td {
    color: #C0C4CC;
    background-color: #ebeef5;
  }

  .gray1 input {
    display: none;
  }

</style>





// WEBPACK FOOTER //
// src/components/warehouse/AddStorageBadFrame.vue